import { Injectable } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { NetworkService } from './network.service';
import { WishListService } from './wish-list.service';
import { LanguageService } from './language.service';
import { CartService } from './cart.service';
import { objectKeysToCamelCase } from '../../utils';

@Injectable()
export class UserService {
  user = {
      id: 0,
      firstName: '',
      lastName: '',
      email: ''
  };
  private productList = [];
  constructor(
    private toastr: ToastrService,
    private network: NetworkService,
    private wishList: WishListService,
    private cartService: CartService,
    private languageService: LanguageService
  ) {}

  initUser () {
    this.network
      .fetchUserData()
      .then(response => {
        const fetchedUser = objectKeysToCamelCase(response);

        for (let key in fetchedUser) {
            this.user[key] = fetchedUser[key];
        }
      });

    this.network
      .fetchUserProductList()
      .then(fetchedProductList => {
        this.productList.length = 0;
        for (let key in fetchedProductList) {
            this.productList[key] = fetchedProductList[key];
        }
      });
    this.wishList.activate();
    this.cartService.activate();
  }

  getUserInfo() {
    return this.user;
  }

  getUserFullName() {
      return this.user.firstName + ' ' + this.user.lastName;
  }

  getBoughtCourses() {
      return this.productList;
  }

  isProductPurchased(id) {
    const index = this.productList.findIndex(item => {
      return item.id === id;
    });
    return index > -1;
  }

  updateUserInfo(body) {
    return this.network
    .updateUserInfo(body)
    .then(response => {
      const updatedUser = objectKeysToCamelCase(response);

      for(let key in updatedUser) {
        this.user[key] = updatedUser[key];
      }

      this.toastr.success(this.languageService.translate('MESSAGES.USER_UPDATE_SUCCESS'), 'Success');
      return Promise.resolve();
    })
    .catch(err => {
      this.toastr.error(err.message, 'Error');
    })
  }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/core/services/user.service.ts